import { reloadPage } from "./navigationUtils";

// A deploy removes the previous build's files, and Vite renames every chunk on
// each build, so a tab opened before the deploy 404s when it lazy loads a page
// (e-signature, ID check). Vite fires vite:preloadError when that import fails,
// and a reload fetches the new index.html and its chunks.
//
// The timestamp stops a real outage reloading in a loop: a second failure
// within the cooldown falls through to the ErrorBoundary as before. Without
// sessionStorage there is no guard, so the page does not reload.
const RELOADED_AT_KEY = "staleChunkReloadedAt";
const RELOAD_COOLDOWN_MS = 60_000;

function reloadOnStaleChunk() {
  try {
    const reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY));
    if (Date.now() - reloadedAt < RELOAD_COOLDOWN_MS) return;
    sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
  } catch {
    return;
  }
  reloadPage();
}

export { RELOADED_AT_KEY, reloadOnStaleChunk };
